export default function string(s) {
  const empty = () => !s || !s.trim();

  return { empty };
}



// WEBPACK FOOTER //
// ./app/lib/strings.js